export enum keyType {
    number = 'number',
    backspace = 'backspace',
    separator = 'separator',
    caretMove = 'caretMove',
    other = 'other',
}

export const getKeyType = (key: string): keyType => {
    const KEYS_CURSOR_MOVE = ['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'Home', 'End'];

    if (/^\d$/.test(key)) {
        return keyType.number;
    }

    if (key === 'Backspace') {
        return keyType.backspace;
    }

    if ('.,'.includes(key)) {
        return keyType.separator;
    }

    if (KEYS_CURSOR_MOVE.includes(key)) {
        return keyType.caretMove;
    }

    return keyType.other;
};
